import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { iif, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { User } from '@site-mate/dashpivot-shared-library';

import { AnalyticsService } from 'app/analytics/analytics.service';
import { ChartSettings } from 'app/shared/model/charts/chart-settings.model';
import { ChartUtilsService } from 'app/shared/service/chart-utils.service';
import { CompanyService } from 'app/shared/service/company.service';
import { ConfirmService } from 'app/shared/service/confirm.service';
import { ErrorHandler } from 'app/shared/service/error-handler.service';
import { RouteParamsService } from 'app/shared/service/route-params.service';
import { TeamService } from 'app/shared/service/team.service';
import { ToastrService } from 'app/shared/service/toastr.service';
import { UserService } from 'app/user/user.service';

import { ChartsGridComponent } from '../charts-grid/charts-grid.component';

@Component({
  selector: 'cc-charts-register',
  templateUrl: './charts-register.component.html',
  styleUrls: ['./charts-register.component.scss'],
})
export class ChartsRegisterComponent extends ChartsGridComponent implements OnInit {
  users = new Map<string, User>();

  constructor(
    protected readonly routeParamsService: RouteParamsService,
    protected readonly analyticsService: AnalyticsService,
    protected readonly route: ActivatedRoute,
    protected readonly router: Router,
    protected readonly confirmService: ConfirmService,
    protected readonly toastrService: ToastrService,
    protected readonly errorHandler: ErrorHandler,
    protected readonly userService: UserService,
    protected readonly modalService: NgbModal,
    protected readonly teamService: TeamService,
    public readonly chartUtilsService: ChartUtilsService,
    private readonly companyService: CompanyService,
  ) {
    super(
      routeParamsService,
      analyticsService,
      route,
      router,
      confirmService,
      toastrService,
      errorHandler,
      userService,
      teamService,
      modalService,
      chartUtilsService,
    );
  }

  ngOnInit(): void {
    super.ngOnInit();

    of({})
      .pipe(
        mergeMap(() =>
          iif(
            () => this.companyId,
            this.companyService.getUsers(this.companyId),
            this.teamService.getUsers(this.teamId),
          ),
        ),
      )
      .subscribe(
        (users: User[]) => {
          users.forEach((user) => this.users.set(user.id, user));
        },
        (error) => this.errorHandler.handle(error),
      );
  }

  handleSelectAll(charts: ChartSettings[], select) {
    charts.forEach((chart) => this.onSelectionToggle(chart, select));
  }

  getUser(userId): User {
    return this.users.get(userId);
  }
}
